import React, { useState, useEffect, useContext } from 'react';
import './Header.css';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import Logo from '../../assets/images/logo.jpg';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Box } from '@mui/material';
import { CustomerContext } from '../Context/CustomerContext';

const clientOption = [
  {
    name: 'Trang tài khoản',
    slug: '/client-info',
  },
  {
    name: 'Đơn hàng',
    slug: '/client-info/order',
  },
  {
    name: 'Tài khoản',
    slug: '/client-info/edit-account',
  },
];

const trainOption = [
  {
    name: `Khoá workshop`,
    slug: `/post/khoa-workshop`,
  },
  {
    name: `Khoá cơ bản`,
    slug: `/post/khoa-co-ban`,
  },
  {
    name: `Khoá cắm hoa mở shop`,
    slug: `/post/khoa-cam-hoa-mo-shop`,
  },
  {
    name: `Học viên`,
    slug: `/post/hoc-vien`,
  },
];

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug, id } = useParams();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [data, setData] = useState([]);
  const { customerData } = useContext(CustomerContext);
  const [clientInfo, setClientInfo] = useState(customerData ?? {});
  const [searchQuery, setSearchQuery] = useState(``);
  const [activeKey, setActiveKey] = useState(-1);
  const [activeContact, setActiveContact] = useState(false);
  const [activeNews, setActiveNews] = useState(false);
  const [activeImage, setActiveImage] = useState(false);
  const [activeTrain, setActiveTrain] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    setIsSubMenuOpen(false);
    setActiveNews(false);
    setActiveContact(false);
    setActiveImage(false);
    setActiveTrain(false);
    setActiveKey(-2);
  };

  const toggleSearch = () => {
    setIsSearchOpen(!isSearchOpen);
  };

  const toggleSubMenu = () => {
    setIsSubMenuOpen(!isSubMenuOpen);
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add('no-scroll-y');
    } else {
      document.body.classList.remove('no-scroll-y');
    }
    return () => {
      document.body.classList.remove('no-scroll-y');
    };
  }, [isSidebarOpen]);

  const clientToken = localStorage.getItem('client_token');
  useEffect(() => {
    if (location.pathname.endsWith(`/`)) {
      setActiveNews(false);
      setActiveContact(false);
      setActiveImage(false);
      setActiveTrain(false);
      setActiveKey(-1);
    } else {
      if (slug) {
        setActiveNews(false);
        setActiveContact(false);
        setActiveImage(false);
        setActiveTrain(false);
        if (slug == 'product') {
          axios
            .get(`/api/v1/products/get-cate-parent-by-slug/` + id)
            .then((res) => {
              const key = data.findIndex(
                (item) => item.id === res.data.parentCategory.id
              );
              setActiveKey(key);
            })
            .catch((err) => console.log(err));
        } else {
          const key = data.findIndex((item) => item.slug === slug);
          if (key == -1) {
          } else {
            setActiveKey(key);
          }
        }
      } else if (!slug && id) {
        if (
          id == 'khoa-workshop' ||
          id == 'khoa-co-ban' ||
          id == 'khoa-cam-hoa-mo-shop'
        ) {
          setActiveNews(false);
          setActiveContact(false);
          setActiveImage(false);
          setActiveTrain(true);
          setActiveKey(-2);
        } else {
          if (location.pathname.startsWith('/support')) {
            setActiveNews(false);
            setActiveContact(false);
            setActiveImage(false);
            setActiveTrain(false);
            setActiveKey(-2);
          } else {
            setActiveNews(true);
            setActiveContact(false);
            setActiveImage(false);
            setActiveTrain(false);
            setActiveKey(-2);
          }
        }
      }
    }

    setSearchQuery(``);
    if (clientToken) {
      setClientInfo(customerData);
      setIsLogin(true);
    }
    setIsSearchOpen(false);
    setIsSidebarOpen(false);
  }, [navigate, customerData]);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/categories/navbar`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err));
  };

  const handleLogout = () => {
    navigate(`/`);
    setIsSidebarOpen(false);
    localStorage.removeItem(`client_token`);
    localStorage.removeItem(`client_id`);
    setIsLogin(false);
    toast('Đăng xuất thành công!', {
      type: 'success',
      autoClose: 1000,
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/tim-kiem?s=${searchQuery}`);
    } else {
      navigate(`/tim-kiem?s=`);
    }
  };

  const handleActiveKey = (key) => {
    if (key == 50) {
      setActiveKey(-2);
      setActiveNews(false);
      setActiveContact(true);
      setActiveImage(false);
      setActiveTrain(false);
    } else if (key == 49) {
      setActiveKey(-2);
      setActiveNews(false);
      setActiveContact(false);
      setActiveImage(true);
      setActiveTrain(false);
    } else if (key == 48) {
      setActiveKey(-2);
      setActiveNews(true);
      setActiveContact(false);
      setActiveImage(false);
      setActiveTrain(false);
    } else if (key == 47) {
      setActiveKey(-2);
      setActiveNews(false);
      setActiveContact(false);
      setActiveImage(false);
      setActiveTrain(true);
    } else {
      setActiveNews(false);
      setActiveContact(false);
      setActiveImage(false);
      setActiveTrain(false);
      setActiveKey(key);
    }
  };

  return (
    <div>
      <div className="header-container-parent">
        <div className="header-container-child">
          <div className="header-left">
            <div className="marquee-container">
              <div className="marquee">THANH FLOWER VƯỜN HOA CẦN THƠ</div>
            </div>
          </div>
          <div className="header-right">
            <span>
              <Link to={`/support/gioi-thieu`}>Giới thiệu</Link>
            </span>
            {/* <span>
              <Link>Kiểm tra đơn hàng</Link>
            </span> */}
            <span>
              {isLogin ? (
                <Box>
                  <Link to={`/client-info`}>
                    {clientInfo == null ? '' : clientInfo.visibleName}
                    <i className="bi bi-person-fill ms-1"></i>
                  </Link>
                  <div className="dropdown-login">
                    <div className="dropdown-menu">
                      {clientOption.map((subItem, subIdx) => (
                        <Link to={subItem.slug} key={subIdx}>
                          <div className="dropdown-item">{subItem.name}</div>
                        </Link>
                      ))}
                      <div className="dropdown-item" onClick={handleLogout}>
                        Đăng xuất
                      </div>
                    </div>
                  </div>
                </Box>
              ) : (
                <Link to={`/login`}>Đăng nhập / Đăng ký</Link>
              )}
            </span>
          </div>
        </div>
      </div>
      <div className="header-container-parent">
        <div className="header-container-child">
          <div className="header-left" onClick={() => handleActiveKey(-1)}>
            <Link className="logo-head" to="/" title="SHOP HOA THANH">
              <img src={Logo} alt="" />
            </Link>
          </div>
          <div className="header-second">
            <span>
              <div className="search-box">
                <input
                  type="text"
                  name="s"
                  placeholder="Tìm Kiếm..."
                  id="search"
                  className="search-input"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button onClick={handleSearch}>
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </span>
            <span>
              <Link to={`/cart`}>
                <i className="bi bi-cart-fill"></i>
              </Link>
            </span>
          </div>
        </div>
      </div>
      <div className="header-container-parent">
        <div className="header-container-child">
          <div
            className={`navbar-item ${activeKey == -1 ? 'active' : ''}`}
            onClick={() => handleActiveKey(-1)}
          >
            <Link to={`/`}>
              <i className="bi bi-house-heart" style={{ color: '#c6c6c6' }}></i>{' '}
              Home
            </Link>
          </div>
          {data.map((item, idx) =>
            item.items.length > 0 ? (
              <div
                className={`navbar-item ${activeKey == idx ? 'active' : ''}`}
                key={idx}
                onClick={() => handleActiveKey(idx)}
              >
                <Link to={item.slug}>
                  {item.name}{' '}
                  <i
                    className="bi bi-chevron-down"
                    style={{ fontSize: '12px' }}
                  ></i>
                </Link>
                {item.items.length > 0 && (
                  <div className="dropdown">
                    <div className="dropdown-menu">
                      {item.items.map((subItem, subIdx) => (
                        <Link to={subItem.slug} key={subIdx}>
                          <div className="dropdown-item">{subItem.name}</div>
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div
                className={`navbar-item ${activeKey == idx ? 'active' : ''}`}
                key={idx}
                onClick={() => handleActiveKey(idx)}
              >
                <Link to={item.slug}>{item.name}</Link>
              </div>
            )
          )}
          <div className={`navbar-item ${activeTrain ? 'active' : ''}`}>
            <Link>
              Đào tạo
              <i
                className="bi bi-chevron-down ms-2"
                style={{ fontSize: '12px' }}
              ></i>
            </Link>
            <div className="dropdown">
              <div className="dropdown-menu">
                {trainOption.map((subItem, subIdx) => (
                  <div key={subIdx} onClick={() => handleActiveKey(47)}>
                    <Link to={subItem.slug}>
                      <div className="dropdown-item">{subItem.name}</div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className={`navbar-item ${activeNews ? 'active' : ''}`}
            onClick={() => handleActiveKey(48)}
          >
            <Link to={`/news`}>Tin tức</Link>
          </div>
          {/* <div
            className={`navbar-item ${activeImage ? "active" : ""}`}
            onClick={() => handleActiveKey(49)}
          >
            <Link to={`/active-image`}>Hình ảnh hoạt động</Link>
          </div> */}
          <div
            className={`navbar-item ${activeContact ? 'active' : ''}`}
            onClick={() => handleActiveKey(50)}
          >
            <Link to={`/contact`}>Liên hệ</Link>
          </div>
        </div>
      </div>

      <div className="header-container-responsive">
        <div className="header-responsive-left" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
        </div>
        <div className="header-responsive-mid">
          <Link className="logo-head" to="/" title="SHOP HOA THANH">
            <img src={Logo} alt="" />
          </Link>
        </div>
        <div className="header-responsive-right" onClick={toggleSearch}>
          <i className="bi bi-search"></i>
        </div>
      </div>
      <div
        className={`search-responsive-container ${isSearchOpen ? 'open' : ''}`}
      >
        <span>
          <form action="/tim-kiem" method="get" className="search-box">
            <input
              type="text"
              name="s"
              placeholder="Tìm Kiếm..."
              id="search-hidden"
              className="search-input"
            />
            <button type="submit">
              <i className="bi bi-search"></i>
            </button>
          </form>
        </span>
      </div>

      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <button className="close-btn" onClick={toggleSidebar}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>
        <ul className="sidebar-menu">
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              <Link to="/">
                <li>
                  <i
                    className="bi bi-house-heart"
                    style={{ color: '#ccc', padding: 0 }}
                  ></i>{' '}
                  Home
                </li>
              </Link>
            </div>
          </div>
          {data.map((item, idx) => (
            <div className="sidebar-menu-layout" key={idx}>
              <div className="sidebar-menu-item">
                <Link to={item.slug}>
                  <li>{item.name}</li>
                </Link>
                {item.items.length > 0 && (
                  <i
                    className={`bi ${
                      isSubMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'
                    }`}
                    onClick={() => handleActiveKey(idx)}
                  ></i>
                )}
              </div>
              {item.items.length > 0 && (
                <ul
                  className={`sidebar-submenu ${
                    activeKey == idx ? 'open' : ''
                  }`}
                >
                  {item.items.map((subItem, idx) => (
                    <Link to={subItem.slug} key={idx}>
                      {subItem.name}
                    </Link>
                  ))}
                </ul>
              )}
            </div>
          ))}
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              <Link>
                <li>Đào tạo</li>
              </Link>
              <i
                className={`bi ${
                  isSubMenuOpen ? 'bi-chevron-up' : 'bi-chevron-down'
                }`}
                onClick={() => {
                  handleActiveKey(47);
                }}
              ></i>
            </div>
            <ul className={`sidebar-submenu ${activeTrain ? 'open' : ''}`}>
              {trainOption.map((subItem, idx) => (
                <Link to={subItem.slug} key={idx}>
                  {subItem.name}
                </Link>
              ))}
            </ul>
          </div>
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              <Link to="/news">
                <li>Tin tức</li>
              </Link>
            </div>
          </div>
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              <Link to="/active-image">
                <li>Hình ảnh hoạt động</li>
              </Link>
            </div>
          </div>
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              <Link to="/contact">
                <li>Liên hệ</li>
              </Link>
            </div>
          </div>
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              {isLogin ? (
                <Link to="/client-info">
                  <li>{clientInfo.visibleName}</li>
                </Link>
              ) : (
                <Link to="/login">
                  <li>Đăng nhập</li>
                </Link>
              )}
            </div>
          </div>
          <div className="sidebar-menu-layout">
            <div className="sidebar-menu-item">
              <Link to="/cart">
                <li>
                  <i
                    className="bi bi-cart-fill"
                    style={{ color: '#ccc', padding: 0 }}
                  ></i>{' '}
                  Giỏ hàng
                </li>
              </Link>
            </div>
          </div>
          {isLogin && (
            <div className="sidebar-menu-layout" onClick={handleLogout}>
              <div className="sidebar-menu-item">
                <Link>
                  <li>Đăng xuất</li>
                </Link>
              </div>
            </div>
          )}
        </ul>
      </div>

      {/* Overlay */}
      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </div>
  );
};

export default Header;
